'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var nthHookTheme = require('@narvar/nth-hook-theme');
var IconButton = require('@narvar/nth-bit-icon-button');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var IconButton__default = /*#__PURE__*/_interopDefaultLegacy(IconButton);

const IconFilledButton = _ref => {
  let {
    Icon,
    s,
    sHover,
    sIcon,
    ...props
  } = _ref;
  const theme = nthHookTheme.useTheme();
  const {
    color,
    fill,
    ...iconStyle
  } = theme.iconsPrimaryNone ?? {};
  const backgroundColor = fill ?? color ?? '#000';
  return /*#__PURE__*/React__default["default"].createElement(IconButton__default["default"], _extends__default["default"]({
    s: {
      background: backgroundColor,
      padding: '0.25rem',
      borderRadius: '50%',
      '&:hover': {
        background: backgroundColor,
        opacity: 0.3,
        ...sHover
      },
      ...s
    }
  }, props), /*#__PURE__*/React__default["default"].createElement(Icon, {
    s: {
      display: 'block',
      fill: '#fff',
      color: '#fff',
      ...iconStyle,
      ...sIcon
    }
  }));
};
var IconFilledButton$1 = nthHookTheme.withThemeProvider(IconFilledButton, {
  themeTokens: ['iconsPrimaryNone']
});

exports["default"] = IconFilledButton$1;
